import styles from '../FilterCompanyMobile/FilterCompanyMobile.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'

import { useState } from 'react'
import CustomButton from '../UI/CustomButton/CustomButton'

interface Props {
  onClickHandler: () => void
  closeFilter: () => void
  filterData: any
  setFilterData: (selected: string) => void
  title: string
}

const FilterReportMobile: React.FC<Props> = ({
  onClickHandler,
  filterData,
  setFilterData,
  closeFilter,
  title,
}) => {
  const [selected, setSelected] = useState<string>('')

  return (
    <div className={styles.filterContainer}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <img onClick={onClickHandler} src={arrowLeft} alt='Back' />
          <div>{title}</div>
        </div>
        <div className={styles.content}>
          {filterData.map((item: any) => (
            <div
              onClick={() => setSelected(item.value)}
              className={
                selected === item.label
                  ? `${styles.active} ${styles.contentItem}`
                  : styles.contentItem
              }
              key={item.id}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <CustomButton
          title='Применить'
          className={styles.filtersBtn}
          type='button'
          onClick={() => {
            setFilterData(selected)
            onClickHandler()
            closeFilter()
          }}
        />
      </div>
    </div>
  )
}

export default FilterReportMobile
